module.exports = __webpack_public_path__ + "img/avatar.d4b4a786.png";